/*
 * @Author: zwcong
 * @Description:
 * @Date: 2021-08-17 10:37:30
 * @LastEditTime: 2022-03-10 16:58:38
 * @FilePath: /teacher-h5/src/store/modules/studentDetails.js
 */
const state = {
  studentInfo: {},
  summaryData: null, // 学生汇总数据
  cardList: [], // 学习卡数据
  subjectList: [], // 科目列表
  gradeList: [], // 年级列表
  activeSubjectId: '', // 当前科目
  activeGradeId: '' // 当前年级
}

// 自定义改变state初始值的方法
const mutations = {
  setInfo(state, obj) {
    state.summaryData = obj
  },
  setCardList(state, data) {
    state.cardList = data
  },
  setSubjectList(state, data) {
    state.subjectList = data
    if (data && data.length) {
      state.activeSubjectId = data[0].subjectId
    } else {
      state.activeSubjectId = undefined
    }
  },
  setGradeList(state, data) {
    state.gradeList = data
    if (data && data.length) {
      state.activeGradeId = data[0].gradeId
    } else {
      state.activeGradeId = undefined
    }
  },
  setActiveSubjectId(state, data) {
    state.activeSubjectId = data
  },
  setActiveGradeId(state, data) {
    state.activeGradeId = data
  },
  setStudentInfo(state, data) {
    state.studentInfo = data
  }
}

// 自定义触发mutations里函数的方法
const actions = {
  // disInfo ({ commit }, obj) {
  //   commit('setInfo', obj)
  // },
  // disCardList({ commit }, data) {
  //   commit('setCardList', data)
  // }
}

const getters = {
  summaryData: state => state.summaryData,
  cardList: state => state.cardList,
  subjectList: state => state.subjectList,
  gradeList: state => state.gradeList,
  activeSubjectId: state => state.activeSubjectId,
  activeGradeId: state => state.activeGradeId,
  studentInfo: state => state.studentInfo
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
